'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.usermanual.list', [])
  .controller('UsermanualListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/usermanual/list/index.js